import script from "./ArticlesDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesDetail.vue?vue&type=script&setup=true&lang=ts"

import "./ArticlesDetail.vue?vue&type=style&index=0&id=6b5f3a52&lang=scss"

const __exports__ = script;

export default __exports__